<template>
  <div class="dep-detail">
    <Header title="营业部详情"></Header>
    <div class="head">
      <div class="dep-name">{{ departmentInfo.salesDepartmentName }}</div>
      <div class="sep"></div>
      <div class="describe">
        <div>
          <div class="top-text">营业部性质</div>
          <div class="bottom-text">{{ departmentInfo.natureName || '--' }}</div>
        </div>
        <div>
          <div class="top-text">操作风格</div>
          <div class="bottom-text">{{ departmentInfo.styleName || '--' }}</div>          
        </div>
        <div>
          <div class="top-text">帮派</div>
          <div class="bottom-text">{{ departmentInfo.factionName || '--' }}</div>          
        </div>
      </div>
      <div class="wide-dep"></div>
      <div class="bangdan">个股榜单</div>
      <div class="title">
        <div class="top-text date">股票/日期</div>
        <div class="top-text hangq">上榜日行情</div>
        <div class="top-text buy-money">买卖金额</div>
        <div class="top-text sale-money">次日涨幅</div>
      </div>
      <div class="stock-list">
        <div class="iterm" v-for="(iterm, key) in optionList" :key="key" @click="$router.push(`/stock/detail/${iterm.secuCode}.html`)">
          <div class="date">
            <div class="stock-name">{{ iterm.chiNameAbbr }}</div>
            <div class="stock-date">{{ iterm.tradingDay }}</div>
          </div>
          <div class="hangq">
            <div class="hangq-top" :class="{'green-text': iterm.pxChangeRate<0,'black-text':!iterm.pxChangeRate}">
              {{ iterm.pxChangeRate | float2percent }}
            </div>
            <div class="hangq-bottom">{{ iterm.closePrice }}</div>
          </div>
          <div class="buy-money">
            <div class="buy-top">{{ iterm.totalRankBuySum | formatUnit }}</div>
            <div class="buy-bottom green-text">{{ iterm.totalRankSaleSum | formatUnit }}</div>
          </div>
          <div class="sale-money perc" v-if="iterm.nextPxChangeRate" :class="{'green-text': iterm.nextPxChangeRate<0}">
            {{ iterm.nextPxChangeRate | float2percent }}
          </div>
          <div class="sale-money perc" v-else>--</div>
        </div>
        <infinite-loading  @infinite="infiniteHandler" direction="bottom" :distance="100">
           <div slot="spinner" class="tab-spinner">正在加载...</div>
        </infinite-loading>
      </div>
    </div>
  </div>


</template>
<script>
import Header from '../header.vue';
import {request} from '@/api/request';
import {formatUnit} from '@/utils/formatUnit';
import InfiniteLoading from 'vue-infinite-loading';
import SafariAdapter from '../mixin/safari-adapter-mixin';
export default {
  mixins: [SafariAdapter],
  components: {
      Header,
      InfiniteLoading
  },
  data() {
    return {
      departmentId: this.$route.params.id,
      departmentInfo: {},
      page: 0,
      optionList: [],
    }
  },
  async created() {
    this.departmentInfo = await this.getDepartmentDetail();
  },
  methods: {
    async getDepartmentDetail() {
      return await request.get({
        url: request.apis.rank.departmentDetail,
        params: {
          departmentId: this.departmentId
        }
      });
    },
    async getDepOptionList() {
      const list = (await request.get({
        url: request.apis.rank.depOptionList,
        params: {
          departmentId: this.departmentId,
          pageSize: 30,
          page: this.page + 1
        }
      }))['list'];
      if (list && list.length) {
        this.page += 1;
        return list;
      }
      return [];    
    },
    async infiniteHandler($state) {
      const list = await this.getDepOptionList(this.page);
      if (list.length) {
        this.optionList = this.optionList.concat(list);
        $state.loaded();
      } else {
        $state.complete();
      }      
    }
  },
  filters: {
    float2percent(num) {
      if (!num) return 0;
      return (num * 100).toFixed(2) * 1 + '%';
    },
    formatUnit(num) {
      if(!num) return 0;
      return formatUnit(num);
    },
  }
}
</script>

<style lang="stylus" src="./sales.styl" scoped></style>